import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileDTO } from '../../dtos/file.dto';
import { UploadType } from '../../enums/upload-type.enum';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class PdEventEvidenceFileService extends FileService {
  override uploadType = UploadType.PD_EVENT_EVIDENCE;

  userId: number | null = null;

  setUserId(id: number | null) {
    this.userId = id;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postFormRequest(
      `growelab/pd/user/${this.userId}/transcript/attachment`,
      formData,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  override deleteFile(file: FileDTO) {
    const basedId = window.btoa(file.id.toString());
    return this.apiService.deleteRequest(
      `uploads/delete/pd_event_attachment/${basedId}`
    );
  }
}
